export const SITE_NAME =
  "Smarter Spaces - Computer Vision Based Intelligence from Bondstein";
